const clear = $('.filter__active').html()
const KESEARCH_FILTER_SCROLL_KEY = 'kesearch-filter-scroll-target'

function storeKeSearchFilterScrollTarget(targetSelector) {
	try {
		window.sessionStorage.setItem(KESEARCH_FILTER_SCROLL_KEY, targetSelector)
	} catch (error) {
		// Ignore storage issues and keep default navigation behavior.
	}
}

function restoreKeSearchFilterScrollTarget() {
	let targetSelector = null

	try {
		targetSelector = window.sessionStorage.getItem(KESEARCH_FILTER_SCROLL_KEY)
		window.sessionStorage.removeItem(KESEARCH_FILTER_SCROLL_KEY)
	} catch (error) {
		targetSelector = null
	}

	if (!targetSelector) {
		return
	}

	const $target = $(targetSelector).first()
	if (!$target.length) {
		return
	}

	window.requestAnimationFrame(() => {
		const top = Math.max($target.offset().top - 24, 0)
		window.scrollTo({
			top,
			behavior: 'smooth'
		})
	})
}

$('.filter > ul > li > span').click(function (event) {
	if ($(this).parent().hasClass('active')) {
		$(this).parent().removeClass('active')
		return false
	}
	$('.filter > ul > li').removeClass('active')
	$(this).parent().toggleClass('active')
})

$('.filter > ul .filter__apply').click(function (event) {
	$('.filter > ul > li.active').removeClass('active')
})

function getActiveFilters() {
	var activeFilters = ''
	$('form.filter:not(.solr-facets) :checkbox:checked').each(function (index, el) {
		var check = $(this)
		activeFilters +=
			'<li><span data-id="#' +
			check.attr('id') +
			'"><i class="icon icon--plus" aria-hidden="true"><svg><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#svg-icon-plus"></use></svg></i>' +
			check.next().find('span').html() +
			'</span></li>'
	})
	activeFilters += clear
	$('.filter__active').html(activeFilters)
}
getActiveFilters()

$('form.filter:not(.solr-facets) input[type="checkbox"]').change(function (event) {
	getActiveFilters()
})

$('.filter:not(.solr-facets) .filter__active').on('click', 'span', function (event) {
	let $updateButton = $('.tx-pxa-product-manager [data-update-filter]')

	if ($updateButton.hasClass('filter-update-disabled')) {
	} else {
		if ($(this).parent().hasClass('clear')) {
			$('form.filter :checkbox:checked').each(function (index, el) {
				$(this).prop('checked', false)
			})
		} else {
			$($(this).data('id')).prop('checked', false)
		}
		getActiveFilters()
	}
})

$('.ke-search__sidebar .filter > ul > li > ul a').click(function () {
	storeKeSearchFilterScrollTarget('.ke-search__sidebar')
})

$(function () {
	restoreKeSearchFilterScrollTarget()
})
